// 验证手机号码
export function checkPhone(phone) {
  if (!(/^1[3456789]\d{9}$/.test(phone))) {
    return false;
  } else {
    return true;
  }
}
// 验证邮箱
export function checkEmail(email) {
  if (!(/^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/.test(email))) {
    return false;
  } else {
    return true;
  }
}

// 生成随机验证码
export function getCode(n=4) {
  var all = "azxcvbnmsdfghjklqwertyuiopZXCVBNMASDFGHJKLQWERTYUIOP0123456789";
  var b = "";
  for (var i = 0; i < n; i++) {
   var index = Math.floor(Math.random() * 62);
   b += all.charAt(index);
 
  }
  return b;
 }

 // 获取表单验证规则
//  [{label:'xxx',key:'xxx'}] 基本用法
export function getRules(formArr) {
  let rules = {}

  formArr.map(item => {
    let obj = {
      required: true,
      trigger: "blur",
      type: "string",
      message: "请输入" + item.label,
      validator: {}
    }
    // 是否需要验证
    if (typeof item.required == "boolean") {
      obj.required = item.required
    }
    // 验证类型判断
    if (item.radio || item.select || item.check) {
      obj.trigger = "change"
      obj.message = obj.message.replace("输入", "选择")
      obj.type = "number"
    }
    if (item.check) {
      obj.type = "array"
    }
    if (item.type) {
      obj.type = item.type
    }
    if (item.formatNum) {
      obj.type = "number"
    }
    // 验证规则
    if (item.trigger) {
      obj.trigger = item.trigger
    } else if (item.rule == "phone") {
      obj.message = ""
      obj.validator = (rule, value, callback, source, options) => {
        if (value) {
          if (!checkPhone(value)) {
            callback("手机号有误")
          } else {
            callback()
          }
        } else {
          callback("请输入手机号")
        }
      }
    } else if (item.rule == "email") {
      delete obj.message
      obj.validator = (rule, value, callback, source, options) => {
        if (value) {
          !checkEmail(value) ? callback("邮箱有误") : callback()
        } else {
          obj.required ? callback("请输入邮箱") : callback()
        }
      }
    }
    // 验证最大字数
    if (item.maxSize) {
      delete obj.message
      obj.validator = (rule, value, callback, source, options) => {
        if (value) {
          value.length > item.maxSize ? callback("限制输入" + item.maxSize + "个字符") : callback()
        } else {
          obj.required ? callback("请输入" + item.label) : callback()
        }
      }
    }
    rules[item.key] = [obj]
  })
  return rules
}

